<template>
	<core-loading-button
		v-bind="$attrs"
		:color="disabled ? 'outline' : $get('color', 'green')"
		:loading="saving"
		:disabled="isDisabled"
		button-type="submit"
		v-on="$listeners"
	>
		<template v-if="finished && !hasFailed"><slot name="successText">Saved!</slot></template>
		<template v-else-if="finished && hasFailed"><slot name="errorText">Error!</slot></template>
		<slot v-else>Save Changes</slot>
	</core-loading-button>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		disabled: Boolean,
		saving: Boolean,
		failed: Boolean,
		color: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			finished: false,
			timeout: false,
			hasFailed: false,
		};
	},
	computed: {
		isDisabled() {
			return this.disabled && !this.finished;
		},
	},
	watch: {
		saving: function (isSaving) {
			if (!isSaving) {
				this.finished = true;
				this.timeout = setTimeout(() => this.completeSave(), 1000);
			}
		},
		disabled: function (isDisabled) {
			if (isDisabled && !this.timeout) {
				this.completeSave();
			}
		},
		failed: function (failed) {
			this.hasFailed = failed;
		},
	},
	methods: {
		completeSave() {
			this.finished = false;
			this.hasFailed = false;
			if (this.timeout) {
				clearTimeout(this.timeout);
			}
		},
	},
};
</script>
